import { FC, PropsWithChildren } from 'react';

import { SWRConfig } from 'swr';

import { OverloadErrorPage } from './overloaded';
import { useOverloadNotification } from '../hooks/useOverloadNotification';
import { createOverloadMiddleware } from '../middleware/swrOverloadMiddleware';


const DEFAULT_SWR_CONFIG = {
  dedupingInterval: 5_000,
  loadingTimeout: 3_000,
  errorRetryCount: 5,
  errorRetryInterval: 5_000,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
};

export const OverloadGuard: FC<PropsWithChildren> = ({ children }) => {
  const { showOverloadNotification, isInCooldown, isOverloaded } = useOverloadNotification();
  const overloadMiddleware = createOverloadMiddleware(showOverloadNotification, isInCooldown);

  return (
    <SWRConfig
      value={{
        ...DEFAULT_SWR_CONFIG,
        use: [overloadMiddleware],
      }}>
      {isOverloaded ? <OverloadErrorPage /> : children}
    </SWRConfig>
  );
};
